module.exports = __webpack_public_path__ + "static/media/04-d-calendar.9696e158.png";